export default __webpack_public_path__ + "static/LAPIERRE_MAIN_16x9_1_Nico_Vouilloz-8c2eb6359d191eddca8d5ff17ca0476c.mp4";